import { getScrollPercentage } from "@utils/index";

const { pushNotifications: { scrollPercentage = 0 } } = window.jrConfigGlobal;
let canShowNotification = false;
if (window.Notification) {
  canShowNotification = window.Notification.permission === 'default';
}
let ScrollDebounce = true;

const onScroll = () => {
  if (ScrollDebounce && canShowNotification && getScrollPercentage() >= scrollPercentage) {
    ScrollDebounce = false;

    const interval = setInterval(() => {
      if (typeof window.Pushnami !== 'undefined') {
        window.Pushnami.update().prompt();

        clearInterval(interval);

        document.removeEventListener('scroll', onScroll);
      }
    }, 500);
  }
}

export const promptPushnamiNotification = (): void => {
  document.addEventListener('scroll', onScroll);
}
